import {
   AppointmentPractitioner,
   PractitionerAbleToCompleteAppointmentQuery,
} from '@dreryk/egabinet-appointment-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { translationKeys } from '../translations';

type GroupSessionsCreateFormLoaderRenderProps = {
   practitioners: AppointmentPractitioner[];
};

type GroupSessionsCreateFormLoaderProps = {
   readonly children: (renderProps: GroupSessionsCreateFormLoaderRenderProps) => JSX.Element;
};

export const GroupSessionsCreateFormLoader = (props: GroupSessionsCreateFormLoaderProps): JSX.Element => {
   const {
      data: practitioners,
      loading: practitionersLoading,
      error: practitionersError,
   } = useCqrsSearch<AppointmentPractitioner>(() => new PractitionerAbleToCompleteAppointmentQuery());

   if (practitionersLoading) {
      return <LoaderSpinner />;
   }

   if (practitionersError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={translationKeys.fetchDataErrorOccurredDuringTherapeuticGroupCreation}
            displayIndicator
         />
      );
   }

   return props.children({
      practitioners: practitioners,
   });
};
